import moment from 'moment';
import React from 'react';
import ImageGallery from 'react-image-gallery';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
moment.locale('ru');

function GeograftourReviews({ reviews }) {
  function getImages(media) {
    if (!media?.images || media.images == null) return [];
    return media.images.map((image) => ({
      original: `/media/${image.image}`,
      thumbnail: `/media/${image.image}`,
      originalClass: 'geo-review__image',
    }));
  }

  return reviews.map((review) => {
    const { author, d_create, id, media, text } = review;
    const officeLink = author.offices[0]?.type
      ? `https://www.geograftour.com/${
          author.offices[0].type === 'freelance' ? 'freelance' : 'office'
        }/${author.offices[0].id}/`
      : false;
    const imageArr = getImages(media);
    const createdAt = moment(d_create).format('DD.MM.YY');

    return (
      <article className="geo-review" key={id}>
        <div className="geo-review__author">
          <img
            src={`/media/${author.image}`}
            alt={`Фото ${author.name}`}
            className="geo-review__author-photo"
            loading="lazy"
          />
          <div className="geo-review__info-container">
            {officeLink ? (
              <Link
                to={officeLink}
                className="geo-review__author-name"
                target="_blank"
              >
                {author.name}
              </Link>
            ) : (
              <div className="geo-review__author-name">{author.name}</div>
            )}
            <div className="geo-review__date">{createdAt}</div>
          </div>
        </div>
        <div
          className="geo-review__comment"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(text),
          }}
        >
          {/* {text} */}
        </div>
        {media?.images?.length > 0 ? (
          <div className="geo-review__images geo-review__media-block">
            <h4 className="geo-review__block-title">Наши фото из отеля</h4>

            <ImageGallery
              items={imageArr}
              originalHeight={450}
              originalWidth={800}
              autoPlay={false}
              showPlayButton={false}
            />
          </div>
        ) : null}
        {media?.videos?.length > 0 ? (
          <div className="geo-review__videos geo-review__media-block">
            <h4 className="geo-review__block-title">
              Наши видео и обзоры из отеля
            </h4>

            {media.videos.map((item) => {
              let link = item.video;
              if (link.includes('video') && link.includes('rutube')) {
                link = link.replace('video', 'play/embed');
              }
              return (
                <div className="geo-review__image">
                  <iframe
                    className="geo-review__iframe"
                    key={item.id}
                    title={'Видео об отеле'}
                    src={link}
                    allow="clipboard-write; autoplay"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    allowFullScreen
                  />
                </div>
              );
            })}
          </div>
        ) : null}
        {media?.videofiles.length > 0 ? (
          <div className="geo-review__videos geo-review__media-block">
            {media.videofiles.map((item) => {
              const link = item.video;
              return (
                <div className="geo-review__image">
                  <video
                    className="geo-review__iframe"
                    key={item.id}
                    title={'Видео об отеле'}
                    src={`/media/${link}`}
                    controls
                    preload="metadata"
                    height={'100%'}
                    width={'100%'}
                  />
                </div>
              );
            })}
          </div>
        ) : null}
      </article>
    );
  });
}
export default GeograftourReviews;
